import React from 'react';

import classNames from 'classnames';

export const Image = ({
  src, 
  className, 
  style,
  maxWidth = 'lg',
  alt = ''
}) => (
  <img
    className={classNames(`max-w-${maxWidth}`, className)}
    style={style}
    src={src}
    alt={alt}
  />
)

export default React.memo(Image);
